import { jsx as d, jsxs as r } from "react/jsx-runtime";
import { c } from "./index.CWkFp9WS.js";
import { useState as $, useEffect as A, useId as y } from "react";
import { O as h } from "./ODSColumn.B8Qu83P2.js";
import { O as N } from "./ODSIcon.DjL6Q3o4.js";
import { O as w } from "./ODSRow.Du_e7gfN.js";
import { O as x } from "./ODSText.D6mgyggF.js";
import '../assets/ODSAccordion.css';const b = ({
  children: n
}) => /* @__PURE__ */ d(x, { as: "span", className: "ODSAccordion-Header", children: n }), U = ({
  size: n = "small",
  disabled: e = !1,
  onToggle: m,
  className: f,
  expanded: s = !1,
  contentSlot: u,
  contentText: i,
  headerText: t,
  ...C
}) => {
  const [o, p] = $(s);
  A(() => p(s), [s]), A(() => {
    i && console.warn(
      "The `contentText` prop for Accordion is deprecated. Please use `contentSlot` instead."
    );
  }, [i]);
  const D = () => {
    p((a) => !a), m && m(!o);
  }, I = (a) => {
    [" ", "Enter"].includes(a.key) && (a.preventDefault(), D());
  }, l = y(), O = `ODSAccordion-Summary-${l}`, S = `ODSAccordion-ContentFrame-${l}`;
  return /* @__PURE__ */ r(
    h,
    {
      className: c(
        "ODSAccordion",
        o && "ODSAccordion--expanded",
        e && "ODSAccordion--disabled",
        `ODSAccordion--expanded-${o}--disabled-${e}`,
        `ODSAccordion--size-${n}`,
        f
      ),
      ...C,
      children: [
        /* @__PURE__ */ r(
          "button",
          {
            id: O,
            tabIndex: 0,
            disabled: e,
            onClick: D,
            onKeyDown: I,
            "aria-expanded": o,
            "aria-controls": S,
            className: c(
              "ODSAccordion-HeaderIcon",
              e && "ODSAccordion-HeaderIcon--disabled",
              `ODSAccordion-HeaderIcon--size-${n}`
            ),
            children: [
              /* @__PURE__ */ d(b, { size: n, children: t }),
              /* @__PURE__ */ d(w, { className: c("ODSAccordion-ExpandAndCollapseIcon"), children: /* @__PURE__ */ d(
                N,
                {
                  name: o ? "collapse-up-type-standard" : "collapse-down-type-standard",
                  decorative: !0,
                  className: c(
                    `${o ? `ODSAccordion-CollapseUp ODSAccordion-CollapseUp--size-${n}` : `ODSAccordion-CollapseDown ODSAccordion-CollapseDown--size-${n}`}`
                  )
                }
              ) })
            ]
          }
        ),
        /* @__PURE__ */ r(
          "div",
          {
            id: S,
            className: c(
              "ODSAccordion-ContentFrame",
              o && "ODSAccordion-ContentFrame--expanded"
            ),
            role: "region",
            "aria-labelledby": O,
            "aria-label": `${t} Content`,
            hidden: !o,
            children: [
              /* @__PURE__ */ r(
                "span",
                {
                  id: `ODSAccordion-ContentSpan-${l}`,
                  className: "sr-only",
                  children: [
                    t,
                    " content"
                  ]
                }
              ),
              u,
              i
            ]
          }
        )
      ]
    }
  );
};
export {
  U as O
};
//# sourceMappingURL=ODSAccordion.CnvXawI7.js.map
